<tlk-banner [type]="type">
	<div tlkBannerBody>
		<ng-content></ng-content>
	</div>
	<button
		tlkBannerRight
		tlkButton
		variant="ghost"
		size="m"
		[attr.aria-label]="'TeethDiagram.BannerCloseAriaText' | translate"
		(click)="onDismiss()"
	>
		<tlk-close-empty-icon />
	</button>
</tlk-banner>
